import React from 'react';
import { useNotifications } from './hooks/useNotifications';
import { useChildren } from './context/ChildProvider';

// Import Screens
import HomeScreen from './screens/HomeScreen';
import ChildFormScreen from './screens/ChildFormScreen';
import EditChildScreen from './screens/EditChildScreen';
import ChildDetailScreen from './screens/ChildDetailScreen';
import AssessmentHubScreen from './screens/AssessmentHubScreen';
import AssessmentScreen from './screens/AssessmentScreen';
import SingleAssessmentScreen from './screens/SingleAssessmentScreen';
import ResultScreen from './screens/ResultScreen';
import ProfileScreen from './screens/ProfileScreen';
import EditProfileScreen from './screens/EditProfileScreen';
import EducationScreen from './screens/EducationScreen';
import StimulationScreen from './screens/StimulationScreen';
import AccessSharedDataScreen from './screens/AccessSharedDataScreen';
import ReportCardScreen from './screens/ReportCardScreen';
import CreateInterventionScreen from './screens/CreateInterventionScreen';
import NotificationScreen from './screens/NotificationScreen';
import AboutScreen from './screens/AboutScreen';
import RecapScreen from './screens/RecapScreen';
import BatchMeasurementScreen from './screens/BatchMeasurementScreen';
import ReferralScreen from './screens/ReferralScreen';
import AdminDashboardScreen from './screens/AdminDashboardScreen';

// Import Components
import Header from './components/Layout';
import BottomNav from './components/BottomNav';
import Toast from './components/Toast';

export default function AppContent({
    user,
    page,
    setPage,
    subPage,
    setSubPage,
    selectedChild,
    setSelectedChild,
    data,
    setData,
    showToast,
    navigate,
    handleBack,
    handleLogout,
    toast,
    setToast
}) {
    const { myChildren, loading: loadingChildren } = useChildren();
    const { unreadCount } = useNotifications(user, myChildren, loadingChildren);

    const renderPage = () => {
        const props = { user, navigate, showToast };
        
        if (subPage) {
            switch (subPage) {
                case 'addChild': return <ChildFormScreen {...props} />;
                case 'editChild': return <EditChildScreen {...props} child={selectedChild} />;
                case 'viewChild': return <ChildDetailScreen {...props} child={selectedChild} />;
                case 'comprehensiveAssessment': return <AssessmentScreen {...props} child={selectedChild} />;
                case 'singleAssessment': return <SingleAssessmentScreen {...props} child={selectedChild} type={data.type} />;
                case 'results': return <ResultScreen {...props} child={selectedChild} assessment={data} />;
                case 'accessSharedData': return <AccessSharedDataScreen {...props} />;
                case 'editProfile': return <EditProfileScreen {...props} />;
                case 'reportCard': return <ReportCardScreen {...props} child={selectedChild} assessments={data.assessments} immunizations={data.immunizations} />;
                case 'createIntervention': return <CreateInterventionScreen {...props} child={selectedChild} />;
                case 'notifications': return <NotificationScreen {...props} />;
                case 'about': return <AboutScreen {...props} />;
                case 'rekapan': return <RecapScreen {...props} />;
                case 'batchMeasurement': return <BatchMeasurementScreen {...props} />;
                case 'referral': return <ReferralScreen {...props} child={selectedChild} />;
                case 'adminDashboard': return <AdminDashboardScreen {...props} />;
                default:
                    navigate('home');
                    return null;
            }
        }
        
        switch (page) {
            case 'assessmentHub': return <AssessmentHubScreen {...props} />;
            case 'stimulation': return <StimulationScreen {...props} />;
            case 'education': return <EducationScreen {...props} />;
            case 'profile': return <ProfileScreen {...props} onLogout={handleLogout} navigate={navigate} />;
            default: return <HomeScreen {...props} />;
        }
    };

    const isFullWidth = subPage === 'adminDashboard';

    return (
        <div className={`${isFullWidth ? 'max-w-7xl w-full' : 'max-w-md'} mx-auto bg-gray-50 shadow-lg min-h-screen font-sans`}>
            <Header page={subPage || page} user={user} navigate={navigate} onBack={handleBack} notificationCount={unreadCount} />
            <main className="p-4 sm:p-6">
                {renderPage()}
            </main>
            <BottomNav activePage={page} navigate={navigate} />
            {toast && <Toast message={toast.message} type={toast.type} onDismiss={() => setToast(null)} />}
        </div>
    );
}